module.exports = __webpack_public_path__ + "img/computer-mouse.1.bf96874e.svg";